import React from 'react';
import type { FiboCollectionComboboxItem } from '@skin-seoul/service';
import { RenderItem } from '@/components/fibosearch/FibosearchCombobox/RenderItem';
export type SimpleListProps = {
  collections: FiboCollectionComboboxItem[];
  inputValue: string;
  onClose?: () => void;
};
export const CollectionList = ({
  inputValue,
  collections,
  onClose
}: SimpleListProps) => <>
    {collections.map(item => <RenderItem key={JSON.stringify(item)} item={item} inputValue={inputValue} onClose={onClose} />)}
  </>;